import { useEffect } from 'react';

import { useCreateGuestProjectMutation } from '@app-velocity/modules/projects';

import { ScenarioRoutePaths } from '@app-velocity/modules/scenarios';

import { ConfigureScenario } from '../ConfigureScenario';
import { ConfigureScenarioContext } from '../context/ConfigureScenarioContext';

import { ConfigureScenarioPageSkeleton } from '../components/ConfigureScenarioPageSkeleton';

export const ConfigureScenarioGuest = () => {
  const { mutate: createGuestProject, data } = useCreateGuestProjectMutation();

  useEffect(() => {
    createGuestProject({
      name: 'My Workspace',
    });
  }, []);

  if (!data) return <ConfigureScenarioPageSkeleton />;

  return (
    <ConfigureScenarioContext.Provider
      value={{
        mode: 'guest',
        workspaceId: data.id,
        teamId: '',
        challengeAFlow: ScenarioRoutePaths.challengeAFlowAsAGuest,
        challengeSimulation: ScenarioRoutePaths.challengeSimulationAsAGuest,
      }}
    >
      <ConfigureScenario />
    </ConfigureScenarioContext.Provider>
  );
};
